import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import FinanceDashboard from 'images/Finance.png';
export default function FinanceDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('financedashboardText', { ns: ['home'] })}</Typography>
      <img src={FinanceDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}
